import { render, staticRenderFns } from "./OnlineClass.vue?vue&type=template&id=1262b860&scoped=true&"
import script from "./OnlineClass.vue?vue&type=script&lang=js&"
export * from "./OnlineClass.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/project-detail.css?vue&type=style&index=0&id=1262b860&scoped=true&lang=css&"
import style1 from "./OnlineClass.vue?vue&type=style&index=1&id=1262b860&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1262b860",
  null
  
)

export default component.exports